const imagePlaceholder = "/static/dist/public/assets/global/noimg-dealer.jpg";

export { imagePlaceholder };
